import { COST_NOTE, formatUsd, type CostSplit } from '../utils/evalCost';

/** "Model $0.07 · Judge $1.48": the two costs side by side, never added together. */
export const CostSplitText = ({ cost, className = '' }: { cost: CostSplit; className?: string }) => (
  <span className={`text-xs text-gray-600 whitespace-nowrap ${className}`} title={COST_NOTE}>
    Model <span className="text-gray-900">{formatUsd(cost.model)}</span>
    <span className="text-gray-400 mx-1">·</span>
    Judge <span className="text-gray-900">{formatUsd(cost.judge)}</span>
  </span>
);
